'use client';

import type { GamificationMissionGroups, MissionsGroupVariants } from '../../types';
import type { MissionTargetActions } from '../MissionsGroup/utils/helpers';
import { MissionsGroup } from '../MissionsGroup';

// INFO: In future we will have also fast missions
const missionGroupOrder: MissionsGroupVariants[] = ['welcome', 'daily', 'weekly'];

interface GamificationMissionsContentProps {
  loading: boolean;
  missionGroups: GamificationMissionGroups;
  onExpired: VoidFunction;
  targetActions?: MissionTargetActions;
}

export const GamificationMissionsContent = ({ loading, missionGroups, onExpired, targetActions }: GamificationMissionsContentProps) => {
  return missionGroupOrder.map(variant => (
    <MissionsGroup
      key={variant}
      variant={variant}
      loading={loading}
      onExpired={onExpired}
      targetActions={targetActions}
      missions={missionGroups[variant].items}
      nextUpdate={missionGroups[variant].nextUpdate}
    />
  ));
};
